export default __webpack_public_path__ + "static/media/radisson_logo.a063b66c.svg";